import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';

import InputText from 'modules/_shared/components/InputText';
import InputError from 'modules/_shared/components/InputError';
import IconTooltip from 'modules/_shared/components/Icon/IconTooltip';
import CustomAsyncSelect from 'modules/_shared/components/CustomAsyncSelect';
import InputNumber from 'modules/_shared/components/InputNumber';

import { MessageType } from 'modules/_shared/components/InputMessage';
import { useAddCoOwnerModal } from '../context/AddCoOwnerModalContext';

const AddCoOwnerModalBody: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAddCoOwnerModal();

  return (
    <Modal.Body>
      {data.hasMembersSelector ? (
        <div className="form-group">
          <label className="form-label" htmlFor="co-owner-name">
            <span className="d-flex flex-row justify-content-start">
              {t('Shareholder')}
              <IconTooltip
                id="encumbrance-shareholder-tooltip"
                tooltip={t('CoOwnerPartnerInfo')}
              />
            </span>
          </label>

          <CustomAsyncSelect
            id="partner-select-input"
            onChange={actions.handleChangeSelectedPartner}
            onFetchData={actions.handleFetchPartnersByTerm}
            value={data.selectedPartner}
            className="react-select-lg"
            placeholder={t('SearchPartner')}
            minimumInputLength={3}
            noDataLabelKey="NoPartnersHaveBeenFound"
            loadingLabelKey="LoadingPartners"
            errorLabelKey="ErrorLoadingPartners"
            defaultOptions={data.partnerOptions}
          />
        </div>
      ) : (
        <div className="form-group">
          <InputText
            id="co-owner-name"
            label={t('Name')}
            value={data.name}
            onChange={actions.handleChangeName}
            required
          />
        </div>
      )}

      <div className="form-group">
        <InputText
          id="co-owner-cif"
          label={t('Cif')}
          value={data.cif}
          onChange={actions.handleChangeCif}
          required
        />
      </div>

      <div className="form-group">
        <InputText
          id="co-owner-email"
          label={t('Email')}
          value={data.email}
          onChange={actions.handleChangeEmail}
          emailInput
          required
          additionalInfo={
            !data.isValidEmail && data.email ? t('InvalidEmail') : ''
          }
          additionalInfoType={MessageType.ERROR}
        />
      </div>

      <InputNumber
        id="co-owner-percentage"
        label={t('Percentage')}
        value={data.percentage}
        onChange={actions.handleChangePercentage}
        iconRight="ni-percent"
        tooltip={t('PercentageOverTheRangeSelected')}
        max={100}
        required
        additionalInfo={!data.isValidPercent ? t('InvalidPercentage') : ''}
        additionalInfoType={MessageType.ERROR}
      />

      <div className="form-group">
        <InputText
          id="co-owner-email"
          label={t('Comment')}
          value={data.comments}
          onChange={actions.handleChangeComments}
        />
      </div>
    </Modal.Body>
  );
};

export default AddCoOwnerModalBody;
